// eslint-disable-next-line simple-import-sort/imports
import AnimatedMoveTitle from 'components/Animation/AnimatedMoveTitle';
import PropTypes from 'prop-types';
import React from 'react';
import { styled } from 'styled-components';

const StyledTitle = styled.h2`
  width: auto;
  text-align: center;
  font-size: 32px;

  @media (max-width: ${({ theme }) => theme.breakpoint.tablet}) {
    font-size: 24px;
  }

  font-weight: 700;
  padding: clamp(0.625rem, 3.636vw - 0.102rem, 14px)
    clamp(1rem, 3.636vw + 0.273rem, 1.25rem);
  border-radius: 33px;
  ${({ $defaultTitle, theme }) =>
    $defaultTitle &&
    ` 
		color:${theme.colors.defaultWhite};
		background: none;
	`};
`;

const SectionTitle = ({ children, defaultTitle, ...rest }) => {
  return (
    <AnimatedMoveTitle defaultTitle={defaultTitle}>
      <StyledTitle $defaultTitle={defaultTitle} {...rest}>
        {children}
      </StyledTitle>
    </AnimatedMoveTitle>
  );
};

SectionTitle.propTypes = {
  children: PropTypes.node.isRequired,
  defaultTitle: PropTypes.bool,
};

export default SectionTitle;
